import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
/* import DeleteIcon from "@material-ui/icons/Delete"; */
import EditIcon from "@material-ui/icons/Edit";
import React from "react";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  container: {
    maxHeight: 400,
  },
  actionBlock: {
    /*  display: "flex",
     justifyContent: "space-evenly", */
  },
});

export default function RenewalTable(props) {
  const classes = useStyles();
  const designList = props.designList;
  const preventDefault = (event) => event.preventDefault();

  const editTableRule = (row, idx) => (e) => {
    props.editTableRule(row, idx);
  };

  const deleteTableRule = (row, idx) => (e) => {
    // props.deleteTableRule(row, idx);
  };

  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table stickyHeader className={classes.table} aria-label="service design table">
        <TableHead>
          <TableRow>
            <TableCell>Percentage of Fund Exhausted</TableCell>
            <TableCell align="center">Alert Message</TableCell>
            <TableCell align="center">Restrict Claim Process</TableCell>
            <TableCell align="center">Client</TableCell>
            <TableCell align="center">Alert Mode</TableCell>
            {props.action &&
              <TableCell align="center">Action</TableCell>
            }
          </TableRow>
        </TableHead>
        <TableBody>
  
          {designList.map((row, idx) => {
            const alertMode = {sms:row.alertModeSms? 'SMS':'', email:row.alertModeEmail? 'Email':'', whatsapp: row.alertModeWhatsapp? 'whatsapp':''} 
            const {sms, email, whatsapp} = alertMode;
            return (
              <TableRow key={row?.serviceType}>
                {/* <TableCell component="th" scope="row">
                  {row?.serviceTypeName}
                </TableCell> */}
                <TableCell align="center">{row?.percentageOfFundExhausted}%</TableCell>
                <TableCell align="center">{row?.alertMessage}</TableCell>
                <TableCell align="center">{row?.restrictClaim && 'Yes' || 'No'}</TableCell>
                <TableCell align="center">{row.groupClient === 'ALL'? 'ALL':row?.groupClient.map(item =>  ` ${item}`)}</TableCell>
                <TableCell align="center">{`${sms} ${email} ${whatsapp}`}</TableCell>
                {props.action &&
                  <TableCell align="center" className={classes.actionBlock}>
                    {/* <Link href="javascript:void(0)" onClick={preventDefault}>
                      <VisibilityIcon />
                    </Link> */}
                    <Link href="javascript:void(0)" onClick={editTableRule(row, idx)}>
                      <EditIcon />
                    </Link>
                    {/* <Link href="javascript:void(0)" onClick={deleteTableRule(row, idx)}>
                      <DeleteIcon />
                    </Link> */}
                  </TableCell>
                }
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
